import { useState } from 'react';
import { Input } from '../../shared/ui/Input/Input';
import { apiRequests } from '../../shared/api/apiRequests';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { toast, ToastContainer } from 'react-toastify';
import { UploadPicture } from '../../features/UploadPicture';

const CreateCountryPage = () => {
  const [mainImg, setMainImage] = useState(null);
  const [form, setForm] = useState({
    title: '',
    code: '',
    mainLanguageId: 1,
  });

  const handleRequest = () => {
    if (!mainImg) {
      toast.error('Необходимо загрузить файл');
      return;
    }

    const formData = new FormData();
    formData.append('mainImg', mainImg);

    const modelForApi = {
      Title: form.title,
      LanguageEntityId: form.mainLanguageId,
    };
    formData.append('model', JSON.stringify(modelForApi));

    const query = apiRequests.countries.create(formData);

    toast
      .promise(query, {
        pending: 'Запрос к серверу',
        error: 'Произошла ошибка',
        success: 'Страна успешно создана',
      })
      .then(() => {
        setForm({
          title: '',
          code: '',
          mainLanguageId: 1,
        });
        // Reset file input by resetting the state and providing a key to the component
        setMainImage(null);
      })
      .catch((error) => {
        // Log the detailed error from the server if available
        const errorMessage = error.response?.data?.error || 'Произошла ошибка';
        console.error('Ошибка при создании страны:', error.response?.data || error);
        toast.error(errorMessage);
      });
  };

  return (
    <div>
      <div className="page-header">
        <div className="page-title">
          <h3>Создание страны</h3>
          <p>Заполните форму для создания новой страны</p>
        </div>
      </div>

      <div className="page-content mb-3">
        <div className="mb-3">
          <Input
            label={'Название'}
            placeholder={'Введите название страны'}
            value={form.title}
            onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
          />
        </div>
        <div className="mb-3">
          <Input
            label={'Код страны'}
            placeholder={'Введите код'}
            value={form.code}
            onChange={(e) => setForm((prev) => ({ ...prev, code: e.target.value }))}
          />
        </div>
        <div className="mb-3">
          <UploadPicture onSelect={setMainImage} key={mainImg ? mainImg.name : 'empty'} />
        </div>
        <div className="mb-3">
          <LanguageOptions
            label="Основной язык"
            onSelect={(value) => setForm((prev) => ({ ...prev, mainLanguageId: Number(value) }))}
          />
        </div>
      </div>

      <div className="button-content button-right">
        <button onClick={handleRequest} className="btn btn-primary">
          Создать
        </button>
      </div>
      <ToastContainer />
    </div>
  );
};

export default CreateCountryPage;
